import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import AppBar from "./components/AppBar";
import Footer from "./components/Footer";
import { Col, Container, Row } from "react-bootstrap";
import { Buttons } from "../components/Buttons/Buttons";
import { useNavigate } from "react-router-dom";
import { MagicStar, HeartTick, Quant, Tag2 } from "iconsax-react";
const About = () => {
  const navigate = useNavigate();
  const handlenavigate = () => {
    navigate("/products");
  };
  useEffect(() => {
    AOS.init({
      offset: 200, // Offset (in px) from the original trigger point
      delay: 0, // Values from 0 to 3000, with step 50ms
      duration: 4000, // Values from 0 to 3000, with step 50ms
      easing: "ease", // Default easing for AOS animations
      mirror: true, // Whether elements should animate out while scrolling past them
    });
  }, []);
  return (
    <>
      <AppBar />
      <img
        src={require("../assets/images/banner/banner_seven.jpg")}
        className="img-fluid w-100"
        alt="product name"
      />
      <>
        <div className="padding bg-white">
          <Container>
            <Row className="align-items-center">
              <Col lg="6" className="py-3">
                <span className="badge bg-danger-subtle text-danger border border-danger-subtle px-3 py-1 rounded-pill bold text-uppercase mb-2">
                  About GMR Crackers
                </span>
                <h2 className="bold text-dark mt-2 mb-3">
                  Sivakasi's Premier <span className="text-danger">Fireworks Destination</span>
                </h2>
                <div className="regular text-secondary lh-lg">
                  <p>
                    Welcome to <strong className="text-dark">GMR Crackers</strong>, your premier destination for certified, high-quality fireworks available in both retail and direct wholesale quantities! As one of the most reputable cracker suppliers in Sivakasi, we offer an extensive catalog of fireworks ranging from traditional sparklers, ground chakkars, and flower pots to giant aerial shells and multi-color sky shots.
                  </p>
                  <p>
                    Our fireworks are ideal for every festival and family milestone — including <strong className="text-dark">Diwali celebrations, New Year events, temple festivals, weddings, and corporate gatherings</strong>. We strictly maintain supreme safety compliance, ensuring all formulations produce rich, vibrant colors with minimal smoke and safe decibel levels.
                  </p>
                  <p className="mb-0">
                    Whether you require a curated gift box for your family or bulk commercial orders for your locality, GMR Crackers guarantees <strong className="text-danger">unbeatable factory pricing, authentic quality, and rapid delivery</strong> across all Indian states.
                  </p>
                </div>
              </Col>
              <Col lg="6" className="py-3 text-center">
                <div className="p-3 bg-light rounded-4 shadow-sm border">
                  <img
                    src={require("../assets/images/about.png")}
                    className="img-fluid rounded-3"
                    alt="About GMR Crackers"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div className="counter padding bg-overlay z">
          <Container>
            <Row>
              <Col lg="12" className="py-3 text-center z">
                <h3 className="bold text-white mb-3">
                  Handpicked Diwali Cracker Collections at 80% Direct Factory Discount!
                </h3>
                <p className="text-white-50 fs-5 mb-4">
                  Check our verified price list and order your Diwali crackers today.
                </p>
                <button
                  className="btn btn-warning btn-lg rounded-pill px-5 py-3 bold text-dark shadow"
                  onClick={handlenavigate}
                >
                  💥 Explore Price List & Order Online
                </button>
              </Col>
            </Row>
          </Container>
        </div>

        <Container className="padding">
          <Row className="g-4 align-items-center">
            <Col lg="12" className="text-center pb-3">
              <span className="badge bg-danger-subtle text-danger border border-danger-subtle px-3 py-1 rounded-pill bold text-uppercase">
                Why Choose Us
              </span>
              <h2 className="bold text-dark mt-2">Why GMR Crackers is the Top Choice</h2>
            </Col>

            <Col lg="4" md="6" xs="12">
              <div className="p-4 bg-white rounded-4 shadow-sm border text-center mb-4" data-aos="zoom-in-right">
                <div className="choose mb-3">
                  <Quant size="32" color="white" />
                </div>
                <h4 className="bold text-dark mb-2">Unmatched Quality</h4>
                <p className="regular text-muted small mb-0 lh-base">
                  Superior raw materials, rich vibrant color formulations, and strict testing protocols guarantee reliable burst every time.
                </p>
              </div>

              <div className="p-4 bg-white rounded-4 shadow-sm border text-center" data-aos="zoom-in-right">
                <div className="choose mb-3">
                  <Tag2 size="32" color="white" />
                </div>
                <h4 className="bold text-dark mb-2">Affordable Factory Pricing</h4>
                <p className="regular text-muted small mb-0 lh-base">
                  Direct Sivakasi manufacturing prices with flat 80% seasonal discounts ensure maximum savings for families and retailers.
                </p>
              </div>
            </Col>

            <Col lg="4" md="6" xs="12" className="text-center my-3 my-lg-0">
              <div className="p-4 bg-white rounded-circle shadow-sm border d-inline-block">
                <img
                  src={require("../assets/images/banner/logo.png")}
                  className="img-fluid chutti"
                  alt="GMR Crackers Emblem"
                  style={{ maxHeight: "170px" }}
                  data-aos="zoom-in"
                />
              </div>
            </Col>

            <Col lg="4" md="6" xs="12">
              <div className="p-4 bg-white rounded-4 shadow-sm border text-center mb-4" data-aos="flip-left">
                <div className="choose mb-3">
                  <MagicStar size="32" color="white" />
                </div>
                <h4 className="bold text-dark mb-2">100% Safe to Use</h4>
                <p className="regular text-muted small mb-0 lh-base">
                  Produced under licensed, eco-friendly statutory guidelines with clear safety warnings and reliable fuse timing.
                </p>
              </div>

              <div className="p-4 bg-white rounded-4 shadow-sm border text-center" data-aos="flip-right">
                <div className="choose mb-3">
                  <HeartTick size="32" color="white" />
                </div>
                <h4 className="bold text-dark mb-2">Customer Satisfaction</h4>
                <p className="regular text-muted small mb-0 lh-base">
                  Dedicated customer service, secure packaging, and reliable logistics ensure timely Diwali dispatch across India.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
        <img
          src={require("../assets/images/banner/banner_et.jpg")}
          className="img-fluid w-100"
          alt="product"
        />
      </>
      <Footer />
    </>
  );
};

export default About;
